import { ConfidenceName, DataStatusName } from "../../constants";

export type EmissionsSourceSummary = {
    id: number;
    scope: number;
    locationId: number;
    locationName: string;
    uniqueReference: string;
    name: string;
    activityDataCo2eKgInPeriod: number;
    isMaterial: boolean;
    dataStatusId: number;
    dataStatusName: DataStatusName;
    itemId: number;
    itemName: string;
    typeId: number;
    typeName: string;
    categoryId: number;
    categoryName: string;
    justification: string;
    dataSourceId?: number;
    dataSourceEmissionsFactorConfidenceId?: number;
    dataSourceEmissionsFactorConfidenceName?: ConfidenceName;
    dataSourceEmissionsFactorConfidenceReason?: string;
};

export type MonthlyEstimates = {
    januaryEstimatedKgCO2e?: number;
    februaryEstimatedKgCO2e?: number;
    marchEstimatedKgCO2e?: number;
    aprilEstimatedKgCO2e?: number;
    mayEstimatedKgCO2e?: number;
    juneEstimatedKgCO2e?: number;
    julyEstimatedKgCO2e?: number;
    augustEstimatedKgCO2e?: number;
    septemberEstimatedKgCO2e?: number;
    octoberEstimatedKgCO2e?: number;
    novemberEstimatedKgCO2e?: number;
    decemberEstimatedKgCO2e?: number;
};

export type EmissionsSourceDetail = {
    id: number;
    scope: number;
    locationId: number;
    locationName: string;
    uniqueReference: string;
    name: string;
    activityDataCo2eKgInLastYear: number;
    isMaterial: boolean;
    dataStatusId: number;
    dataStatusName: DataStatusName;
    itemId: number;
    itemName: string;
    typeId: number;
    typeName: string;
    categoryId: number;
    categoryName: string;
    justification: string;
    dataSourceId?: number;
    dataSourceRawUnit?: string;
    dataSourceRawMaterial?: string;
    dataSourceConversionFactor?: number;
    dataSourceNormalisedUnits?: string;
    dataSourceEmissionsFactor?: number;
    dataSourceEmissionsFactorConfidenceId?: number;
    dataSourceEmissionsFactorConfidenceName?: ConfidenceName;
    dataSourceEmissionsFactorConfidenceReason?: string;
    dataSourceEmissionsFactorActiveFromDate?: string;
} & MonthlyEstimates;

export type CreateEmissionsSourceDto = {
    name: string;
    uniqueReference: string;
    locationId: number;
    itemId: number;
    isMaterial: boolean;
    dataStatusId: number | null;
    justification: string;
    requiredEvidenceTypeIds: string;
} & MonthlyEstimates;

export type UpdateEmissionsSourceDto = {
    name: string;
    uniqueReference: string;
    locationId: number;
    itemId: number;
    justification: string;
};

export type EditMonthlyEstimatesDto = MonthlyEstimates;

export type MakeMeasuredDto = {
    isPrimary: boolean;
    justification: string;
};

export type MakePrimaryDto = {
    justification: string;
};

export type MakeSecondaryDto = {
    justification: string;
};

export type EmissionsSourceItem = {
    id: number;
    name: string;
    typeId: number;
};

export type EmissionsSourceType = {
    id: number;
    name: string;
    categoryId: number;
};

export type EmissionsSourceCategory = {
    id: number;
    name: string;
    scope: number;
};

export type EmissionsSourceAddRequiredEvidenceDto = {
    evidenceTypeId: number;
};

export type EmissionsSourceItems = {
    emissionsSourceItems: EmissionsSourceItem[];
    emissionsSourceTypes: EmissionsSourceType[];
    emissionsSourceCategories: EmissionsSourceCategory[];
};

export const emissionsSourceOrderByKeys = [
    "UniqueReference",
    "Name",
    "LocationName",
    "ItemName",
    "TypeName",
    "CategoryName",
    "Scope",
] as const;

export type EmissionsSourceOrderBy =
    (typeof emissionsSourceOrderByKeys)[number];

export const isEmissionsSourceOrderBy = (
    value: string
): value is EmissionsSourceOrderBy => {
    return emissionsSourceOrderByKeys.includes(value as EmissionsSourceOrderBy);
};
